require('./index.css')

if (process.env.VUE_ENV == 'client') {
  /*var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if(mutation.addedNodes.length !== 0) {
        console.log('added!', mutation.addedNodes)
      } else if(mutation.removedNodes !== 0) {
        console.log('removed!', mutation.removedNodes)
      }
    })
  })

  observer.observe(document.body, { subtree: true, attributes: true, childList: true, characterData: true })*/
}

//var Vue = require('vue')
import Vue from 'vue'
import ga from 'vue-gtag'
import store from '../store'
import router from '../router'
import { sync } from 'vuex-router-sync'

var config = require('app-config');
config.init();

if (process.env.VUE_ENV == 'client') {
  //ga(router, 'UA-57227883-1')
  Vue.use(ga, {
    config: { id: "G-CQJ2ZVG782" }
  }, router);
}

sync(store, router)
require('../vue-filters')(Vue);

const app = new Vue({
  router,
  store,
  template: require('./app.html')
})

//let store = { state: {} }
export { app, router, store }




// WEBPACK FOOTER //
// ./lib/boot/index.js